<template>
  <div class="component-content">
    <div class="component-header">
      <a-row style="width: 100%">
        <a-col :span="4">
          <div style="width: 44px; height: 44px">
            <img
              :src="componentWhiteImg"
              style="width: 100%; height: 100%; margin-top: 5px;cursor: pointer;"
              alt=""
            />
          </div>
        </a-col>
        <a-col :span="10" style="height: 95%"
          ><div class="component-header-text">项目组件</div></a-col
        >
        <a-col
          :span="4"
          :offset="6"
          style="height: 90%; align-items: center; display: flex"
        >
          <a-button
            v-if="addComponentStatus"
            icon="left"
            class="add-component-button"
            @click="changeComponentStatus"
        /></a-col>
      </a-row>
    </div>
    <div class="divideLine" />
    <!-- 默认展示 -->
    <div v-if="!addComponentStatus" style="height: 90%">
      <div class="search-content">
        <a-input-search
          placeholder="请输入组件名称"
          enter-button
          @search="onSearch"
          class="search-input"
        />
        <a-popover trigger="hover">
          <template slot="content">添加组件库</template>
          <a-button
            icon="plus"
            class="add-component-button"
            @click="changeComponentStatus"
          />
        </a-popover>
      </div>
      <div class="tag-list">
        <div
          v-for="(item, index) in tagList"
          :key="index"
          :class="item.value == selectTag ? 'selectTag' : 'tag'"
          @click="clickTag(item.value)"
        >
          {{ item.label }}
        </div>
      </div>
      <div class="default-component">
        <div style="width: 100%">
          <a-collapse :bordered="false" expandIconPosition="right">
            <a-collapse-panel
              v-for="(project, index) in projectListWithComponent"
              :key="index"
              :header="project.name"
              forceRender
            >
              <div ref="showComponent" class="show-component">
                <div
                  style="display: inline-block;"
                  class="component-item"
                  :id="component.id"
                  :key="index"
                  v-for="(component, index) in project.componentList"
                >
                  <Popover :component="component" />
                  <div class="component-item-name">{{ component.title }}</div>
                </div>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>
    </div>

    <!-- 点击新建 -->
    <div v-if="addComponentStatus">
      <div class="search-content">
        <a-input-search
          placeholder="搜索项目"
          enter-button
          @search="onSearch"
          class="search-project-input"
        />
      </div>
      <div class="sort-tabs">
        <div class="sort-text">排序</div>
        <div
          :class="sortRule === 1 ? 'sort-tab-choose' : 'sort-tab'"
          @click="changeSortRule(1)"
        >
          时间
        </div>
        <div
          :class="sortRule === 2 ? 'sort-tab-choose' : 'sort-tab'"
          @click="changeSortRule(2)"
        >
          需求
        </div>
        <div
          :class="sortRule === 3 ? 'sort-tab-choose' : 'sort-tab'"
          @click="changeSortRule(3)"
        >
          浏览量
        </div>
      </div>
      <div class="project-list">
        <div
          class="project-item"
          v-for="(item, index) in addProjectList"
          :key="index"
        >
          <a-row class="project-item-row">
            <a-col :span="2" :offset="1">
              <a-button
                class="project-item-button"
                @click="chooseProject(item.id)"
              >
                <a-icon
                  :type="item.check ? 'plus' : 'minus'"
                  :class="item.check ? 'plus-config' : 'minus-config'"
                />
              </a-button>
            </a-col>
            <a-col :span="6" :offset="1">
              <div class="project-name">{{ item.name }}</div>
            </a-col>
            <a-col :span="15" class="project-item-detail">
              <div>{{ item.time }}</div>
              <div class="project-item-detail-sort">{{ item.need }} 需求</div>
              <div class="project-item-detail-sort">{{ item.browse }} 浏览</div>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import Sortable from "sortablejs";
import componentApi from "@/request/api-manager/component.js";
import Popover from "@/views/edit-page/popover/Popover.vue";
import ProjectFeature from "../../../project-feature.vue";
import Page from "@/utils/Page.js";
import BlockComponent from "@/utils/BlockComponent.js";

import bus from '@/utils/Bus';

export default {
  data() {
    return {
      componentWhiteImg: require("@/assets/edit-page/defaultComponentWhite.png"),
      addimg: require("@/assets/edit-page/add.png"),
      searchValue: "",
      tagList: [
        {
          value: 1,
          label: "默认标签",
        },
        {
          value: 2,
          label: "默认标签",
        },
        {
          value: 3,
          label: "默认标签",
        },
        {
          value: 4,
          label: "默认标签",
        },
      ],
      initFlag: 0,
      // selectTag: 1,
      selectTag: undefined,
      pageId: "",
      page: null,
      pageLoading: false,
      // componentList: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      projectList: [
        "962de4c612a555638840267fba2e72b9",
        "2344e7a6d384bbaa76e634c0422f0e7f",
      ],
      componentList: [],
      projectListWithComponent: [],
      addComponentStatus: false,
      sortRule: 1,
      addProjectList: [
        {
          id: 1,
          check: false,
          name: "项目名称",
          time: "2020-12-25",
          need: 5,
          browse: 10,
        },
        {
          id: 2,
          check: true,
          name: "项目名称",
          time: "2020-12-22",
          need: 5,
          browse: 10,
        },
        {
          id: 3,
          check: true,
          name: "项目名称",
          time: "2020-12-20",
          need: 5,
          browse: 10,
        },
        {
          id: 4,
          check: true,
          name: "项目名称",
          time: "2020-12-25",
          need: 5,
          browse: 10,
        },
        {
          id: 5,
          check: true,
          name: "项目名称",
          time: "2020-12-11",
          need: 5,
          browse: 10,
        },
        {
          id: 6,
          check: true,
          name: "项目名称",
          time: "2020-12-08",
          need: 5,
          browse: 10,
        },
        {
          id: 7,
          check: true,
          name: "项目名称",
          time: "2020-11-28",
          need: 5,
          browse: 10,
        },
      ],
    };
  },
  components: {
    Popover,
  },
  mounted() {
    // 初始化监听事件
    // this.addEventListener();
  },
  async created() {
    // // 获取路由并校验
    // if (!this.getAndCheckRouteInfo()) return;
    // // 获取页面数据，生成Page对象
    // if (!(await this.getPage())) return;
    // // 初始化page视图
    // if (!(await this.initPageLive())) return;
    // 获取组件列表
    this.onSearch("");
  },
  methods: {
    /**
     * 组件列表查询
     * @param {*} value
     */
    onSearch(value) {
      // 获取数据
      componentApi
        .listExtAll({
          projectId: this.projectList.join(","),
          name: `*${value}*`,
          frameworkName: "vue",
        })
        .then((res) => {
          // 处理数据
          this.setProjectListWithComponent(res.result);
          // 初始化Sortable
          if (this.initFlag++ == 0) {
            this.$nextTick(() => {
              var els = this.$refs.showComponent;
              console.log('els', els)
              this.$emit('createSortables', els)
            });
          };
        });
    },

    /**
     * 搜索接口返回值处理
     * @param {*} result 接口返回值
     */
    setProjectListWithComponent(result) {
      // 根据项目ID分组
      this.$emit("setComponentList", result)
      this.projectListWithComponent = 
        _(result)
        .groupBy("projectId")
        .map((value, key) => {
          return { id: key, name: value[0].projectName, componentList: value }
        })
        .value()
    },

    // /**
    //  * 初始化Sortable对象
    //  */
    // initSortable() {
    //   // 初始化Sortable
    //   this.$nextTick(() => {
    //     var els = this.$refs.showComponent;
    //     els.forEach((el) => {
    //       // 创建组件Sortable对象
    //       this.createSortable(el);
    //     });
    //   });
    // },

    // /**
    //  * 创建Sortable拖拽对象
    //  * @param {*} el dom对象
    //  */
    // createSortable(el) {
    //   let self = this;
    //   Sortable.create(el, {
    //     sort: false,
    //     group: { name: "shared", pull: "clone", put: false },
    //     animation: 150,
    //     onEnd: function (evt) {
    //       if(evt.to.className == "sortable-list")
    //         self.addComponent(evt);
    //     },
    //   });
    // },

    changeComponentStatus() {
      this.addComponentStatus = !this.addComponentStatus;
    },
    clickTag(value) {
      let self = this;
      self.selectTag = value;
      console.log("点击事件", self.tagList);
    },
    changeSortRule(value) {
      let self = this;
      self.sortRule = value;
    },
    chooseProject(id) {
      let self = this;
      self.addProjectList.forEach((item) => {
        if (item.id == id) {
          item.check = !item.check;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "./showComponent.css";
</style>